<template>
  <div>
    <div
      class="item-row-alignment margin-top-10"
      v-for="(instruction,index) in instructions"
      :key="instruction+index">
      <weex-text
        class="font-size-sm-base text-color-gray"
        v-html="getIndexText(index)"
        ></weex-text>
      <weex-text
        class="font-size-sm-base text-color-gray"
        v-html="instruction"
        ></weex-text>
    </div>
  </div>
</template>

<script>


  export default {
    name: "ActivityRedirectItem",
    props: {
      instructions: {
        type: Array,
        required: true,
        default: () => []
      },

      useBulletForIndexing: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      getIndexText(instructionIndex) {
        if (this.useBulletForIndexing) {
          return "&#8226;&#160;";
        } else {
          return `${instructionIndex + 1}.&#160;`;
        }
      }
    }
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
